import "./Cards.css";
import { useState, useEffect } from "react";

const Cards = () => {
    const [projects, setProjects] = useState([]);
    useEffect(() => {
    fetch("https://api.github.com/users/Vishaal-batcoderda/repos")
        .then(res => res.json())
        .then(data => {
            const sorted = data.sort(
                (a, b) => new Date(b.created_at) - new Date(a.created_at)
            );
            setProjects(sorted);
                      }
            );
    }, []);

  return (
  <section className="cards">

    {/* ===== PROJECTS ===== */}
    <div className="section" id="projects">
      <h2 className="section-title">Projects</h2>
      <p className="section-subtitle">
        Things I've built to learn, experiment, and solve problems.
      </p>
        <div className="projects-grid">
        {projects.slice(0,6).map((repo) => (
            <div key={repo.id} className="project-card">
                <div className="project-card-header">
                    <h4 style={{ textTransform: "capitalize" }}>{repo.name.replace(/-/g," ")}</h4>
                    {repo.language && (
                        <span className="project-language">{repo.language}</span>
                    )}
                </div>

                <p className="project-description">
                    {repo.description || "No description available."}
                </p>

                {/* Tech stack badges from GitHub topics */}
                {repo.topics && repo.topics.length > 0 && (
                    <div className="project-topics">
                        {repo.topics.map((topic) => (
                            <span key={topic} className="topic-badge">{topic}</span>
                        ))}
                    </div>
                )}

                <div className="project-actions">
                    <a href={repo.html_url} target="_blank" rel="noreferrer">
                        <button className="btn-github">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z"/>
                            </svg>
                            View Code
                        </button>
                    </a>
                    {repo.homepage && (
                        <a href={repo.homepage} target="_blank" rel="noreferrer">
                            <button className="btn-demo">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/>
                                    <polyline points="15 3 21 3 21 9"/>
                                    <line x1="10" y1="14" x2="21" y2="3"/>
                                </svg>
                                Live Demo
                            </button>
                        </a>
                    )}
                </div>
            </div>
        ))}
        </div>
    </div>

    {/* ===== SKILLS ===== */}
    <div className="section" id="skills">
      <h2 className="section-title">Skills</h2>
      <p className="section-subtitle">
        Not just what I use — but how I think about building software.
      </p>
      <div className="skills-grid">

        <div className="skill-card">
          <h4 className="skill-card-title">Programming</h4>
          <p className="skill-card-desc">
            I pick the language after I understand the problem. The thinking matters more than the syntax.
          </p>
          <div className="skill-tags">
            <span>Python</span>
            <span>Java</span>
            <span>C</span>
            <span>JavaScript</span>
          </div>
        </div>

        <div className="skill-card">
          <h4 className="skill-card-title">Frontend</h4>
          <p className="skill-card-desc">
            I notice when something feels off by a few pixels. Good interfaces are the ones you don't have to think about.
          </p>
          <div className="skill-tags">
            <span>React</span>
            <span>HTML5</span>
            <span>CSS3</span>
            <span>Tailwind CSS</span>
          </div>
        </div>

        <div className="skill-card">
          <h4 className="skill-card-title">Backend</h4>
          <p className="skill-card-desc">
            The part users never see is usually where the most interesting problems are. I like figuring out how data moves between things.
          </p>
          <div className="skill-tags">
            <span>FastAPI</span>
            <span>Node.js</span>
            <span>Express</span>
            <span>REST APIs</span>
            <span>MongoDB</span>
          </div>
        </div>

        <div className="skill-card">
          <h4 className="skill-card-title">AI & Machine Learning</h4>
          <p className="skill-card-desc">
            The math took a while to click, but once it did, I started seeing patterns everywhere. The more I learn, the more interested I am in how models actually work under the hood.
          </p>
          <div className="skill-tags">
            <span>NumPy</span>
            <span>Pandas</span>
            <span>Scikit-learn</span>
            <span>Regression</span>
            <span>Classification</span>
            <span>Regularization</span>
            <span>Feature Engineering</span>
          </div>
        </div>

        <div className="skill-card">
          <h4 className="skill-card-title">AI Systems</h4>
          <p className="skill-card-desc">
            Building systems where AI agents reason, use tools, and work together. This is where most of my recent work has been.
          </p>
          <div className="skill-tags">
            <span>LangGraph</span>
            <span>Tool Calling</span>
            <span>Prompt Engineering</span>
            <span>Agent Workflows</span>
            <span>Gemini API</span>
            <span>Local LLMs</span>
          </div>
        </div>

        <div className="skill-card">
          <h4 className="skill-card-title">Software Engineering</h4>
          <p className="skill-card-desc">
            I try to write code that someone else could read six months later without asking me what it does.
          </p>
          <div className="skill-tags">
            <span>Modular Architecture</span>
            <span>Component-Based Design</span>
            <span>API Design</span>
            <span>Git</span>
            <span>GitHub</span>
            <span>Linux</span>
          </div>
        </div>

        <div className="skill-card">
          <h4 className="skill-card-title">Development Workflow</h4>
          <p className="skill-card-desc">
            I build in small steps, test frequently, and refactor once it works. Writing code that is easy to understand is just as important as writing code that runs.
          </p>
          <div className="skill-tags">
            <span>Debugging</span>
            <span>Refactoring</span>
            <span>Code Review</span>
            <span>Testing</span>
            <span>Version Control</span>
          </div>
        </div>

      </div>
    </div>

  </section>
);
};

export default Cards;